import { render, staticRenderFns } from "./SurveyDepartmentReport.vue?vue&type=template&id=0b660728"
import script from "./SurveyDepartmentReport.vue?vue&type=script&lang=js"
export * from "./SurveyDepartmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports